<template>
  <div class="dialog" v-show="isShow">
    <div class="mask" @click="maskClick"></div>
    <div class="content">
      <i class="icon-success"></i>
      <div class="tip">提交申请成功</div>
      <small>我们会在48小时内与您取得联系</small>
      <button @click= "maskClick">关闭</button>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data(){
     return {
       isShow: false
    }
  }
  ,
  methods: {
    maskClick(e){
      this.isShow = false;
    },
    show(f){
      this.isShow = f
    }
  }

}
</script>

<style scoped lang="scss">
.icon-success{
  width: 65px;
  height: 65px;
  display: inline-block;
  background-image: url('./assets/image/icon-success.png');
}
.dialog{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  color:#333;
}
.mask{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.content{
  background-color: #fff;
  border-radius: 4px;
  width: 560px;
  padding: 30px 0;
  font-size: 16px;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .icon-success{
    display: block;
    margin: 0 auto 34px;
  }
  .tip{
    font-size: 24px;
    margin-bottom: 12px;
  }
  button{
    display: block;
    margin: 36px auto 0;
    border: 1px solid #b1b1b1;
    line-height: 38px;
    padding: 0 28px;
    border-radius: 4px;
    border: none;
  }
}
@media screen  and(max-width: 414px){
  .content{
    width: 80%;
  }
}


</style>



// WEBPACK FOOTER //
// src/apps/siteindex/join-success.vue